import * as d3 from 'd3'

export default {
  methods: {

    chart_Controller(d) {

      let actData = this.chartData.filter(f=> f.CDATE <= this.cutoff)
      let data = this.chartData
      
      // Bar Chart 
      this.draw_BarChart_Up(actData) // -----> below
      this.draw_BarChart_Down(actData) // -----> below
 


      // Line Chart 
      this.chart.styles.filter(f=> f.type == 'LINE').forEach((st,i)=> {
        if (st.act == 'Y') data = actData
        this.draw_LineChart(data, st)
      })
    },


    draw_BarChart_Up(_data) {
      
      _data.forEach(d=> {
        
        let y_ = this.chart.height/2
        this.chart.styles.filter(f=> f.type == 'BAR' && f.dir == 'UP').forEach(st=> {
          
          let value = (d[st.code] < 0) ? 0 : d[st.code]

          this.canvasChart
          .append('rect')
          .attr('x', d.mx - st.size/2).attr('y', y_-this.primary.axis(value))
          .attr('width', st.size).attr('height', this.primary.axis(value))
          .attr('fill', st.color).attr('opacity', st.opacity)

          if(st.vSize > 0 && value > 0) {
            this.canvasChart
            .append('text')
            .attr('x', d.mx).attr('y', y_-this.primary.axis(value) -2)
            .attr('font-size', st.vSize).attr('fill',  st.vColor).attr('text-anchor', 'middle')
            .text(value)
          }

          y_ -= this.primary.axis(value)
        })
      })

    },

    
    draw_BarChart_Down(_data) {
      
      _data.forEach((d,i)=> {
        
        let y_ = this.chart.height/2
        this.chart.styles.filter(f=> f.type == 'BAR' && f.dir == 'DOWN').forEach(st=> {

          let value = (d[st.code] < 0) ? 0 : d[st.code]

          this.canvasChart
          .append('rect')
          .attr('x', d.mx - st.size/2)
          .attr('y', y_)
          .attr('width', st.size).attr('height', this.primary.axis(value))
          .attr('fill', st.color).attr('opacity', st.opacity)

          if(st.vSize > 0 && value > 0) {
            this.canvasChart
            .append('text')
            .attr('x', d.mx)
            .attr('y', y_ + this.primary.axis(value) + 2 + st.vSize*0.75)
            .attr('font-size', st.vSize).attr('fill',  st.vColor)
            .attr('text-anchor', 'middle')
            .text(value)
          }
          y_ += this.primary.axis(value)
        })
      })
    },



    draw_LineChart(_data, st) {
      let lineFunc = d3.line()
      .x(d => d.mx)
      .y(d => (this.secondary.axis(st.dir=='DOWN' ? -d[st.code] : d[st.code])/2))

      this.canvasChart
      .append('path')
      .attr('d', lineFunc(_data))
      .attr('stroke', st.color).attr('stroke-width', st.size)
      .attr('fill', 'none').attr('opacity', st.opacity)
      .style("stroke-dasharray", (st.ltype, st.ltype))

      _data.forEach((d,i)=> {
        // Node
        if(st.node > 0) {
          this.canvasChart
          .append('circle')
          .attr('cx', d.mx)
          .attr('cy', (this.secondary.axis(st.dir=='DOWN' ? -d[st.code] : d[st.code]))/2)
          .attr('r', st.node)
          .attr('fill', st.color).attr('opacity', st.opacity)
        }
        // Value
        if(st.vSize > 0 && d[st.code] > 0) {
          this.canvasChart
          .append('text')
          .attr('x', d.mx)
          .attr('y', (this.secondary.axis(st.dir=='DOWN' ? -d[st.code] : d[st.code]) -4)/2)
          .attr('font-size', st.vSize).attr('fill',  st.vColor)
          .attr('text-anchor', 'middle')
          .text(d[st.code])
        }
      })
    },


  }
}